/* eslint-disable camelcase */
import Layout from '../../layout'
import {globalStylesProtection} from '../../../constants'
import {useExperiment} from '../../../experimentFramework/experiment'
import EXPERIMENT_CONFIG from '../../../experimentFramework/experimentConfigPrivateai.json'

import PrivateaiV1 from './PrivateaiV1'
import {getUserAgent, isIOS, isAndroid, isIpad} from '../../../util/userAgent'

const PrivateaiPage = ({languageCode = `en`}) => {
    let os = 'unsupported'
    if (isIOS() || isIpad()) os = 'ios'
    if (isAndroid()) os = 'android'
    const {experiment: experimentId} = useExperiment(EXPERIMENT_CONFIG, os)
    return (
        <Layout globalStyles={globalStylesProtection}>
            <PrivateaiV1 os={os} browser={getUserAgent()} experimentId={experimentId} languageCode={languageCode} />
        </Layout>
    )
}

export default PrivateaiPage
